<div class="flex flex-col w-full mb-4">
    <div *ngIf="loading" class="flex items-center justify-center w-full h-full">
        <app-loading-indicator></app-loading-indicator>
    </div>

    <ng-container *ngIf="!loading">
        <label *ngIf="label" class="mb-2 pl-2.5 block body-small-regular text-gray-900">
            {{label}}
        </label>
        
        <mat-radio-group 
            [(ngModel)]="value" 
            [ngClass]="{
                'flex': true,
                'flex-col': layoutDirection === RadioButtonLayoutDirection.Vertical,
                'gap-2': layoutDirection === RadioButtonLayoutDirection.Vertical,
                'flex-row': layoutDirection === RadioButtonLayoutDirection.Horizontal,
                'gap-8': layoutDirection === RadioButtonLayoutDirection.Horizontal,
            }"
            [attr.id]="id">
            @for (option of options; track $index) {
                <mat-radio-button
                    [id]= "generateId(option)"
                    [name]="name"
                    [value]="option.value">{{option.label}}
                </mat-radio-button>
            }
            
        </mat-radio-group>
    </ng-container>
</div>
